export default "__VITE_ASSET__62f1a56c__"